import React from "react";

import Stack from "@mui/material/Stack";

export interface BodyProps {
  children?: React.ReactNode;
}

export const Body = ({ children }: BodyProps) => {
  return (
    <Stack
      spacing={4}
      sx={{ flex: 1, minHeight: 0, overflowY: "auto", padding: 4 }}
    >
      {children}
    </Stack>
  );
};
